import { Geometry } from "../models/enum/geometry.enum"
import { Address } from "../models/interfaces/arrival/address.interface"
import { Gate } from "../models/interfaces/arrival/gate.interface"
import { Location } from 'src/app/data/models/interfaces/arrival/location.interface'

export const buildVoidGate = (): Gate => {
  return {
    id: '',
    name: '',
    address: {
      address: '',
      shortAddress: '',
      district: '',
      city: '',
      state: '',
      zipCode: '',
      complement: '',
      location: {
        typeGeoJson: Geometry.POINT,
        coordinates: [0, 0]
      },
    },
    idsResponsables: [],
    idsClassrooms: [],
    idSchool: ''
  } as Gate
}

const buildLocation = (place: google.maps.places.PlaceGeometry): Location => {
  return {
    typeGeoJson: Geometry.POINT,
    coordinates: [place.location.lat(), place.location.lng()],
  }
}

export const buildAddress = (address: google.maps.places.PlaceResult): Address => {
  let zipCode = ''
  let district = ''
  let city = ''
  let state = ''

  for (const component of address.address_components as google.maps.GeocoderAddressComponent[]) {
    // @ts-ignore remove once typings fixed
    const componentType = component.types[0];

    switch (componentType) {
      case "postal_code": {
        zipCode = component.short_name
        break;
      }
      case "sublocality_level_1": {
        district = component.short_name
        break;
      }
      case "administrative_area_level_2": {
        city = component.short_name
        break;
      }
      case "administrative_area_level_1": {
        state = component.short_name
        break;
      }
    }
  }
  return {
    address: address.formatted_address!,
    shortAddress: address.name,
    district: district,
    city: city,
    state: state,
    complement: '',
    zipCode: zipCode,
    location: buildLocation(address.geometry!)
  }
}
